import React from 'react'
const ShoppingCart = ({ width = 20, height = 20, color = '#fff' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="6.29167" cy="16.9928" r="1.29167" fill={color} />
    <circle cx="14.625" cy="16.9928" r="1.29167" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.09541 3.3776H1.25V1.71094H3.74921L4.95984 2.83347L5.16796 4.35544H18.8172L18.1566 12.8679L16.1075 14.7811H4.51991L3.61288 5.28489L3.38933 3.65014L3.09541 3.3776ZM5.35755 6.02211L6.03497 13.1144H15.4504L16.5451 12.0923L17.0162 6.02211H5.35755Z"
      fill={color}
    />
  </svg>
)
export default ShoppingCart
